"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickTrigger = ClickTrigger;
exports.EmptyTrigger = EmptyTrigger;
exports.FocusTrigger = FocusTrigger;
exports.HoverTrigger = HoverTrigger;
exports.buildinTriggers = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _useOutsideClick2 = require("../_utils/hooks/useOutsideClick");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var buildinTriggers = exports.buildinTriggers = {
  click: ClickTrigger,
  hover: HoverTrigger,
  focus: FocusTrigger,
  empty: EmptyTrigger
};

/**
 * 点击的时候打开
 *
 * - children 上绑定 onClick 事件，点击时打开
 * - children 上添加 useClickOutside Hook，外部点击时关闭，并排除 overlayElement
 */
function ClickTrigger(_ref) {
  var childrenElementRef = _ref.childrenElementRef,
    overlayElementRef = _ref.overlayElementRef,
    visible = _ref.visible,
    setVisible = _ref.setVisible,
    _ref$openDelay = _ref.openDelay,
    openDelay = _ref$openDelay === void 0 ? 0 : _ref$openDelay,
    _ref$closeDelay = _ref.closeDelay,
    closeDelay = _ref$closeDelay === void 0 ? 0 : _ref$closeDelay,
    render = _ref.render;
  var _useOutsideClick = (0, _useOutsideClick2.useOutsideClick)([childrenElementRef, overlayElementRef]),
    listen = _useOutsideClick.listen;
  listen(function () {
    return visible && setVisible(false, closeDelay);
  });
  return render({
    overlayProps: {},
    childrenProps: {
      onClick: function onClick() {
        return setVisible(!visible, openDelay);
      }
    }
  });
}

/**
 * 鼠标经过的时候打开
 */
function HoverTrigger(_ref2) {
  var setVisible = _ref2.setVisible,
    _ref2$openDelay = _ref2.openDelay,
    openDelay = _ref2$openDelay === void 0 ? 50 : _ref2$openDelay,
    _ref2$closeDelay = _ref2.closeDelay,
    closeDelay = _ref2$closeDelay === void 0 ? 100 : _ref2$closeDelay,
    render = _ref2.render;
  var commonProps = {
    onMouseEnter: function onMouseEnter() {
      return setVisible(true, openDelay);
    },
    onMouseLeave: function onMouseLeave() {
      return setVisible(false, closeDelay);
    }
  };
  return render({
    overlayProps: commonProps,
    childrenProps: commonProps
  });
}
function FocusTrigger(_ref3) {
  var setVisible = _ref3.setVisible,
    _ref3$openDelay = _ref3.openDelay,
    openDelay = _ref3$openDelay === void 0 ? 50 : _ref3$openDelay,
    _ref3$closeDelay = _ref3.closeDelay,
    closeDelay = _ref3$closeDelay === void 0 ? 100 : _ref3$closeDelay,
    render = _ref3.render;
  var commonProps = {
    onFocus: function onFocus() {
      return setVisible(true, openDelay);
    },
    onBlur: function onBlur() {
      return setVisible(false, closeDelay);
    }
  };
  return render({
    overlayProps: _objectSpread(_objectSpread({}, commonProps), {}, {
      tabIndex: 1000
    }),
    childrenProps: commonProps
  });
}

/**
 * 表示空的触发交互
 */
function EmptyTrigger(props) {
  return props.render({
    overlayProps: {},
    childrenProps: {}
  });
}